module.exports = __webpack_public_path__ + "img/jcfw.2b660af8.png";